import { injectReducer } from "store/reducers";
import withAsyncRouteLoading from "UIComponents/AsyncRouteLoadingHoc";
import AttendanceCategoryMapping from "./routes/AttendanceCategoryMapping";
import AttendanceSyncDashboard from "./routes/AttendanceSyncDashboard";
export default store => ({
  path: ":curriculum_id",
  component: withAsyncRouteLoading(
    () =>
      Promise.all([
        import(/* webpackChunkName: "admin-attendanceSync" */ "./components"),
        import(
          /* webpackChunkName: "admin-attendanceSync" */ "./modules/AttendanceSyncSetupModule"
        ),
        import(
          /* webpackChunkName: "admin-schoolSetup-integrations" */ "Integrations/modules/IntegrationsModule"
        ),
      ]).then(([importedModule0, importedModule1, importedModule2]) => {
        const component = importedModule0.default;
        const module = importedModule1;
        const reducer = module.default;
        const key = module.NAME;
        const integrationsModuleKey = importedModule2.NAME;
        const integrationsModuleReducer = importedModule2.default;

        injectReducer(store, {
          key,
          reducer,
        });

        injectReducer(store, {
          key: integrationsModuleKey,
          reducer: integrationsModuleReducer,
        });
        return component;
      })
    //.catch(err => {
    //   throw err;
    // })
  ),
  childRoutes: [
    AttendanceSyncDashboard(store),
    AttendanceCategoryMapping(store),
  ],
});
